import { render, staticRenderFns } from "./ReportForms.vue?vue&type=template&id=715b38a1&scoped=true&"
import script from "./ReportForms.vue?vue&type=script&lang=js&"
export * from "./ReportForms.vue?vue&type=script&lang=js&"
import style0 from "./ReportForms.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ReportForms.vue?vue&type=style&index=1&id=715b38a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715b38a1",
  null
  
)

export default component.exports